
import AOS                      from 'aos'
import lottie                   from 'lottie-web';
import mobileDashboardJson      from '../../animations/mobile-dashboard.json';
import UiHelper                 from '_utils/UiHelper';
import videoModal               from '../../shared/video-modal';


let spacedRepetitionAnim, scrollDownIcon, primaryAbstractAnchor, secondaryAbstractAnchor, spacedRepetitionBand, abstractBand, mobileAnimation, mobileLottie, band1WatchVideoButton, tableOfContents, backToTocThresholdElement, 
  backToTocLink, navbarHeight, tableOfContentsParent;

const whyItWorksPage = {

  init: function () {

    /*
    ==================================================
      INIT SUB MODULES
    ==================================================
    */

    AOS.init();

    /*
    ======================================================
    INIT DYNAMIC ADJUSTMENT OF VIEWPORT HEIGHT FOR MOBILE
    ======================================================
    */
   
    UiHelper.adjustViewportHeight();

    /*
    ==================================================
      CACHE DOM ELEMENTS
    ==================================================
    */

    scrollDownIcon = document.querySelector('.band-1 .scroll-down-indicator-icon');
    spacedRepetitionAnim = document.querySelector('.band-2 .graphic .animation');
    primaryAbstractAnchor = document.querySelector('.band-1 .text-button');
    secondaryAbstractAnchor = document.querySelector('.band-5 .text-button');
    spacedRepetitionBand = document.querySelector('.band-2');
    abstractBand = document.querySelector('.band-8');
    mobileAnimation = document.querySelector('.band-5 #mobile-dashboard-animation');
    band1WatchVideoButton = document.querySelector('.band-1 .watch-video-button');
    tableOfContents = document.querySelector('.table-of-contents');
    tableOfContentsParent = document.querySelector('.band-9');
    backToTocThresholdElement = document.querySelector('.band-10.white-paper');
    backToTocLink = document.querySelector('.band-10 .back-to-toc');
    navbarHeight = document.querySelector('.navbar').offsetHeight;

    /*
    ==================================================
    EVENT HANDLERS
    ==================================================
    */

    if (scrollDownIcon) {
      scrollDownIcon.addEventListener("click", () => {
        UiHelper.scrollToElem(spacedRepetitionBand, navbarHeight);
      });
    }

    if (spacedRepetitionAnim) {
      document.addEventListener("scroll", () => {
        this.handleDocumentScroll(spacedRepetitionAnim);
      });
    }

    if (primaryAbstractAnchor || secondaryAbstractAnchor) {
      [primaryAbstractAnchor, secondaryAbstractAnchor].forEach(elem => {
        if (elem) {
          elem.addEventListener("click", () => {
            UiHelper.scrollToElem(abstractBand, navbarHeight);
          });
        }
      });
    }

    if (mobileAnimation) {
      document.addEventListener("scroll", () => {
        this.handleDocumentScroll(mobileAnimation);
      });
    }

    if (band1WatchVideoButton) {
      const videoUrl = band1WatchVideoButton.getAttribute('data-video-url') || null;

      band1WatchVideoButton.addEventListener("click", () => {
        this.handleOpenVideoModalRequest(videoUrl);
      });
    }

    if (tableOfContents) {
      document.addEventListener("click", event => {
        if (event.target.classList.contains("list-item"))
          this.handleTableOfContentsClick(event.target);
        });
    }

    if (backToTocThresholdElement) {
      document.addEventListener("scroll", (e) => {
        this.handleScrollPastElement(e);
      });
    }

    if (backToTocLink) {
      backToTocLink.addEventListener("click", () => {
        UiHelper.scrollToElem(tableOfContentsParent, navbarHeight);
      });
    }


    /*
    ==================================================
    INIT LOTTIE ANIMATIONS
    ==================================================
    */

    mobileLottie = lottie.loadAnimation({
      container: document.getElementById('mobile-dashboard-animation'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: mobileDashboardJson,
    });
  },


  /*
  ==================================================
  LOCAL UTILS
  ==================================================
  */

  handleCloseVideoModalRequest() {
    this.isVideoModalOpen(false);
  },

  handleOpenVideoModalRequest(videoUrl) {
    this.isVideoModalOpen(true, videoUrl);
  },

  handleDocumentScroll(elem) {
    if (elem === spacedRepetitionAnim) {
      let listenerElem = spacedRepetitionAnim;
      let animateElems = spacedRepetitionAnim.querySelectorAll('.square');

      UiHelper.animateElemsIn(listenerElem, animateElems);
    }

    if (elem === mobileAnimation) {
      if (UiHelper.isInViewport(elem)) {
        mobileLottie.play();
      } else {
        mobileLottie.stop();
      }
    }
  },

  handleTableOfContentsClick(elem) {    
    let whitePaperSections = document.querySelectorAll('.white-paper');
    let linkSelected = elem.getAttribute('data-link');

    whitePaperSections.forEach((whitePaperSection) => {
      let section = whitePaperSection.getAttribute('data-link');

      if (section !== linkSelected) {
        return;
      }

      UiHelper.scrollToElem(whitePaperSection, navbarHeight);
    });

  },

  handleScrollPastElement() {
    if (backToTocThresholdElement.getBoundingClientRect().top <= 0) {
      backToTocLink.classList.remove('hidden');
    } else {
      backToTocLink.classList.add('hidden');
    }
  },


  /*
  ==================================================
    LOCAL UTILS
  ==================================================
  */

  isVideoModalOpen(isOpen=false, videoUrl=null) {
    videoModal.render({
      isOpen: isOpen,
      onCloseRequest: () => this.handleCloseVideoModalRequest(),
      selector: '.modals',
      shouldAutoPlay: true,
      videoUrl: videoUrl,
    });
  }
};

export default whyItWorksPage;
